import { InspectionRecord } from '@/entities/inspection';
import { d } from '@/ui/i18n/i18n';

export const useSubmittedForm = () => {
  const existsAndGreaterThanDefault = (date: null | 0 | Date) => date && date.getFullYear() > 1970;

  const getConductedAt = (inspection: InspectionRecord) =>
    //can be null, 0, date. in case of 0 the year will be 1970
    existsAndGreaterThanDefault(inspection.data.inspection.conductedAt)
      ? d(inspection.data.inspection.conductedAt!)
      : existsAndGreaterThanDefault(inspection.data.doneAt) ? d(inspection.data.doneAt!) : null;

  return {
    getConductedAt,
  };
};
